(() => {
  if (window.FTLRunBundle) return;
  const start = Date.parse('2026-10-26T15:00:00Z');
  const end = Date.parse('2026-11-01T12:00:00Z');
  const mainId = 42632625160401, giftId = 42678700540113;
  const marker = 'halloween-10-2026';
  const config = JSON.parse(document.getElementById('ftl-run-config')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const active = () => Date.now() >= start && Date.now() < end;
  const isGift = item => item.properties?._ftl_runsible_bundle === marker;
  const paidQuantity = cart => cart.items.reduce((sum, item) => sum +
    (Number(item.variant_id) === mainId && !item.selling_plan_allocation && !item.properties?._ftl_gift && item.original_line_price > 0 ? item.quantity : 0), 0);
  const request = async (path, body) => {
    const response = await fetch(root + path, body === undefined ? {headers:{Accept:'application/json'}} :
      {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    return result;
  };
  const refresh = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  const showError = error => {
    if (window.FTLGift) return window.FTLGift.showError(error);
    let node = document.getElementById('ftl-run-error');
    if (!node) {
      node = document.createElement('p');node.id='ftl-run-error';node.setAttribute('role','alert');
      node.style.cssText='padding:14px;background:#fff0ed;color:#8b251e';
      (document.querySelector('#mini-cart .drawer__footer, .cart__recap, #main') || document.body).prepend(node);
    }
    node.textContent=error.message || config.error;
  };
  let queue=Promise.resolve();
  const synchronize = async (requireGift=false) => {
    let cart=await request('cart.js');
    const gifts=cart.items.filter(isGift), eligible=active() && paidQuantity(cart)>=10;
    const updates={};
    gifts.forEach((item,index)=>{const qty=eligible && index===0 ? 1 : 0;if(item.quantity!==qty)updates[item.key]=qty;});
    if(Object.keys(updates).length){cart=await request('cart/update.js',{updates});refresh();}
    const confirmed=cart.items.filter(isGift);
    if(confirmed.some(item=>item.final_line_price!==0) || (requireGift && (!eligible || confirmed.length!==1))){
      if(confirmed.length)await request('cart/update.js',{updates:Object.fromEntries(confirmed.map(item=>[item.key,0]))});
      refresh();throw new Error(config.error);
    }
    return cart;
  };
  const sync = required => {queue=queue.catch(()=>{}).then(()=>synchronize(required));return queue;};
  const items = async id => {
    if(!active() || Number(id)!==mainId)throw new Error(config.error);
    // Confirm the live price before allowing a promised half-price pack.
    const product=await request('products/runsible-64.js');
    const variant=product.variants.find(v=>Number(v.id)===mainId);
    if(!variant?.available || !(variant.compare_at_price>variant.price) || variant.price/variant.compare_at_price>.51)throw new Error(config.error);
    const cart=await sync();
    const result=[{id:mainId,quantity:10}];
    if(!cart.items.some(isGift))result.push({id:giftId,quantity:1,properties:{_ftl_runsible_bundle:marker}});
    return result;
  };
  window.FTLRunBundle={sync,items,active};
  let pending=false;
  document.addEventListener('cart:change',()=>{
    if(pending)return;pending=true;
    setTimeout(()=>sync().catch(showError).finally(()=>{pending=false;}),120);
  });
  // The existing WINDSIBLE checkout guard calls sync as part of its validation.
  const allowed=new WeakSet();
  document.addEventListener('submit',async event=>{
    if(window.FTLGift || event.submitter?.name!=='checkout' || allowed.has(event.target))return;
    event.preventDefault();event.stopImmediatePropagation();
    const form=event.target,button=event.submitter;
    if(button.dataset.runChecking)return;
    button.dataset.runChecking='true';
    try{await sync();allowed.add(form);form.requestSubmit(button);allowed.delete(form);}
    catch(error){showError(error);refresh();}
    finally{delete button.dataset.runChecking;}
  },true);
  // Keep stale open pages from offering a bundle beyond the absolute deadline.
  const tick = () => {
    const remaining=Math.max(0,Math.floor((end-Date.now())/1000));
    const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    document.querySelectorAll('[data-run-unit]').forEach(node=>{node.textContent=String(values[node.dataset.runUnit]).padStart(2,'0');});
    const hero=document.querySelector('.ftl-run-hero');
    if(document.querySelector('[data-run-home] .ftl-run-hero'))document.documentElement.classList.toggle('ftl-run-home-active',remaining>0);
    if(remaining===0){
      document.querySelectorAll('[data-ftl-run-promo]').forEach(node=>{node.hidden=true;node.style.display='none';});
      document.querySelectorAll('[data-run-packs]').forEach(pack=>{
        const single=pack.querySelector('[value="1"]');
        if(single && !single.checked){single.checked=true;single.dispatchEvent(new Event('change',{bubbles:true}));}
      });
    }
    return Boolean(document.querySelector('[data-ftl-run-promo]')); 
  };
  if(tick())setInterval(tick,1000);
  if(location.pathname.replace(/\/$/,'').endsWith('/cart'))sync().catch(showError);
})();
